<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="排产周期"
      edit-title
      id-key="CycleId"
      :data="data"
      :line-form="true"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <template v-if="iShow('day')">
          <el-form-item label="天数" prop="Day">
            <el-input
              type="number"
              v-int
              v-model="data.Day"
              placeholder="请输入天数"
            ></el-input>
          </el-form-item>
        </template>
        <template v-if="iShow('StartTime')">
          <el-form-item label="开始时间" prop="StartTime">
            <el-time-picker
              v-model="data.StartTime"
              format='HH:mm'
              value-format="HH:mm"
              placeholder="选择时间"
            ></el-time-picker>
          </el-form-item>
        </template>
        <template v-if="iShow('EndTime')">
          <el-form-item label="结束时间" prop="EndTime">
            <el-time-picker
              v-model="data.EndTime"
              format='HH:mm'
              value-format="HH:mm"
              placeholder="选择时间"
            >
            </el-time-picker>
          </el-form-item>
        </template>
        <el-form-item
          class="formRadio"
          label="按部门还是按设备"
          label-width="130px"
          prop="SchedulingType"
          v-if="iShow('SchedulingType')"
        >
          <el-radio-group v-model="data.SchedulingType">
            <el-radio :label="0">按部门</el-radio>
            <el-radio :label="1">按设备</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="Remarks" v-if="iShow('Remarks')">
          <el-input
            type="textarea"
            maxlength="80"
            :autosize="{ minRows: 2, maxRows: 5 }"
            v-model="data.Remarks"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        CycleId: 0,
        Day: null,
        SchedulingType: 1,
        Remarks: "",
        StartTime: null,
        EndTime: null,
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/cycle").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        Day: [{ required: true, message: "天数不能为空" }],
        StartTime: [{ required: true, message: "开始时间不能为空" }],
        EndTime: [{ required: true, message: "结束时间不能为空" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash ? this.urlHash.split("/").join(""): location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },

    onEditOpened(data) {},

    onClosed() {
      this.showList = [];
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .line_form .formRadio .el-form-item__content {
  border-bottom: none !important;
}
</style>
